import { render, staticRenderFns } from "./DeliveryConstraints.vue?vue&type=template&id=562c4200"
import script from "./DeliveryConstraints.vue?vue&type=script&lang=js"
export * from "./DeliveryConstraints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports